import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getObstetricsSelector } from '../selectors'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { ObstetricsConstants } from '../store/obstetrics.constants'
import { IObstetricsState } from '../store/obstetrics.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { setBodValue } from '../../bodySurvey/store/bodySurvey.actions'
import { compareObjectsIfEqual } from '../../../../../utilities/object.util'
import { initialObstetricsState } from '../store/obstetrics.reducers'

export function* saveObstetrics() {
  const obstetrics: IObstetricsState = yield select(getObstetricsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      let pcrDocUpdated: IPcr = { ...pcrDoc }

      const currentState = { ...obstetrics }
      const initialState = { ...initialObstetricsState }

      if (compareObjectsIfEqual(currentState, initialState)) {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            obstetrics: undefined,
          },
        }
      } else {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            obstetrics,
          },
        }
        yield put(setBodValue(true))
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveObstetrics() error: ${e}`))
    }
  }
}
export function* saveObstetricsSaga() {
  yield takeLatest([ObstetricsConstants.SAVE_OBSTETRICS], performWithMutexHOG, saveObstetrics)
}
